const stravaStreamHillSearch = (gradesStream, distStream, altStream) => {
    const minGrade = 0.0;
    const hills = {};
    const streamPoints = {};
    let ctr = 0;
    let hillStartPt = null;
    let hillEndPt = null;
    for (let i = 0; i < gradesStream.length; i++) { // eslint-disable-line
        if (gradesStream[i] >= minGrade) {
            if (hillStartPt) {
                hillEndPt = i;
            } else if (gradesStream[i + 1] >= minGrade) {
                hillStartPt = i;
                hillEndPt = null;
            }
        } else if (hillStartPt && (hillEndPt - hillStartPt) > 1) {
            // current point downhill or flat & "in" a hill segment, end the hill at prev point
            hillEndPt = i - 1;
            streamPoints[ctr] = {
                streamStartPt: hillStartPt,
                streamEndPt: hillEndPt,
            };

            const dist = distStream[hillEndPt] - distStream[hillStartPt - 1];
            const height = altStream[hillEndPt] - altStream[hillStartPt - 1];
            if (dist > 10) {
                hills[ctr] = {
                    ...streamPoints[ctr],
                    distMeters: Math.round(dist),
                    avgGrade: Math.round((height / dist) * 1000) / 10,
                };
            }
            hillStartPt = null;
            hillEndPt = null;
            ctr += 1;
        }
    }

    return hills;
};

export default stravaStreamHillSearch;



/** WEBPACK FOOTER **
 ** ./src/utils/stravaStreamHillSearch.js
 **/